import type { AdminInvite } from "./types";

/** What the invites table shows: the API status, with "opened" for a pending invite that was viewed. */
export type InviteDisplayState = "pending" | "opened" | "used" | "expired" | "revoked";

export function inviteDisplayState(
  invite: Pick<AdminInvite, "status" | "openedAt">,
): InviteDisplayState {
  if (invite.status === "pending" && invite.openedAt !== null) return "opened";
  return invite.status;
}
